const COLORS = {
  white: "#ffffff",
  background: "#fafafa",
  bjelin_smoke: "#eee",
  bjelin_light_grey: "#dfe2e1",
  bjelin_grey: "#959797",
  bjelin_middlegrey: "#757575",
  bjelin_dark_grey: "#3e3e3e",
  bjelin_light_sand: "#f3efe9",
  bjelin_sand: "#e0d9cd",
  bjelin_brown: "#8c7766",
  bjelin_dark_brown: "#675343",
  bjelin_red: "#d33d3b",
  bjelin_dark_red: "#ad1c1a",
  bjelin_green: "#77854c",
  bjelin_light_green: "#97a767",
  bjelin_dark_green: "#58662e",
  bjelin_alert_green: "#109c48",
  bjelin_blue: "#3c95cc",
  bjelin_light_blue: "#65b0df",
  bjelin_dark_blue: "#2176aa",
  bjelin_orange: "#e6a84e",
  bjelin_orange_dark: "#db8d17"
};

export default COLORS;
